// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"e0ec8ac2","7851":"e0ec8ac2","8426":"bd22e0da"}[chunkId] + ".chunk.css";
};